<template>
	<div id="InviteAccountant">
		<!-- back to team members  -->
		<div class="sm:flex items-center m-auto text-center sm:text-left pt-6">
			<div class="w-full sm:w-1/2 flex mt-auto">
				<vs-button
					color="#2c2c2c"
					type="flat"
					icon-pack="feather"
					icon="icon-arrow-left"
					class="inline"
					@click="goBack"
				/>

				<h2 class="inline ml-2" style="line-height: 35px">{{ $t("Mes collaborateurs") }}</h2>
			</div>
		</div>

		<vs-card class="shadow-none border mt-4 p-6">
			<div class="pb-8 text-center">
				<h4>{{ $t("Invitez un collaborateur à vous rejoindre") }}</h4>
				<p class="mt-4 text-sm">
					{{
						$t(
							"Un email sera envoyé au collaborateur pour qu’il finalise son inscription en rentrant son mot de passe."
						)
					}}
				</p>
			</div>

			<vs-alert :active="msgErr === 401" type="warning" class="my-5">
				{{ $t("L’utilisateur que vous essayez d’inviter a déjà accès à l’application.") }}
			</vs-alert>

			<vs-alert
				:active="msgErr === 403"
				type="warning"
				class="my-5"
				:title="$t('L utilisateur que vous essayez de créer existe déjà')"
			>
				{{ $t("L’utilisateur que vous essayez de créer existe déjà ...") }}
			</vs-alert>

			<vs-alert :active="msgErr === 422" type="warning" class="my-5">
				{{ $t("Une erreur est survenue") }}
			</vs-alert>

			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full">
					<vs-input
						v-model.trim="firstname"
						v-validate="'required'"
						name="firstname"
						color="var(--black)"
						class="w-full"
						:label-placeholder="$t('Prénom')"
						autocomplete="off"
					/>
					<span v-show="errors.has('firstname')" class="text-danger text-sm">
						{{ errors.first("firstname") }}
					</span>
				</div>
				<div class="vx-col sm:w-1/2 w-full">
					<vs-input
						v-model.trim="lastname"
						v-validate="'required'"
						color="var(--black)"
						class="w-full mb-3"
						:label-placeholder="$t('Nom')"
						name="lastname"
						autocomplete="off"
					/>
					<span v-show="errors.has('lastname')" class="text-danger text-sm">
						{{ errors.first("lastname") }}
					</span>
				</div>
			</div>

			<div class="vx-col w-full py-1">
				<vs-input
					v-model.trim="email"
					v-validate="{ required: true, email: true }"
					name="email"
					color="var(--black)"
					class="w-full"
					:label-placeholder="$t('Email')"
					autocomplete="off"
				/>
				<span v-show="errors.has('email')" class="text-danger text-sm">{{ errors.first("email") }}</span>
			</div>

			<div class="vx-col w-full py-1 vs-con-input relative">
				<span
					class="input-span-placeholder vs-input--placeholder normal normal vs-placeholder-label"
					style="font-size: 9.8px; padding-left: 4px"
				>
					{{ $t("Rôle") }}
				</span>

				<select
					v-model="policy_profile_id"
					class="w-full border-solid border py-1 cursor-pointer mt-6"
					:style="{
						'border-color': 'var(--border)',
						height: '32px',
						'border-radius': '6px',
						'padding-left': '6px'
					}"
					name="choose_plan"
				>
					<option v-for="(policy, key) in filtered_policies" :key="key" :value="policy.id">
						<span>{{ $t(policy.name) || key }}</span>
					</option>
				</select>
				<span v-show="errors.has('selectedPolicy')" class="text-danger text-sm">
					{{ errors.first("selectedPolicy") }}
				</span>
			</div>

			<!-- <div class="vx-col w-full py-1">
				<div class="vx-col w-full py-3">
					<vs-checkbox v-model="sendEmail">
						{{ $t("Envoyer un mail d’invitation automatiquement") }}
					</vs-checkbox>
				</div>
			</div>

			<transition name="mdp-appear">
				<div v-if="!sendEmail" class="vx-row mdp">
					<div class="vx-col w-full sm:w-1/2">
						<vs-input
							ref="password"
							v-model="password"
							v-validate="validatePassword"
							class="w-full"
							name="password"
							color="var(--black)"
							type="password"
							:label-placeholder="$t('Mot de passe')"
						/>

						<span v-show="errors.has('password')" class="text-danger text-sm">
							{{ errors.first("password") }}
						</span>
					</div>
					<div class="vx-col w-full sm:w-1/2">
						<vs-input
							ref="password2"
							v-model="password2"
							v-validate="validatePassword2"
							class="w-full"
							name="password2"
							color="var(--black)"
							type="password"
							:label-placeholder="$t('Confirmer le mot de passe')"
						/>

						<span v-show="errors.has('password2')" class="text-danger text-sm">
							{{ errors.first("password2") }}
						</span>
					</div>
				</div>
			</transition> -->

			<div class="vx-row pt-8">
				<div class="vx-col w-full sm:w-1/2">
					<s-button type="border" class="w-full" @click="goBack"> {{ $t("Annuler") }} </s-button>
				</div>
				<div class="vx-col w-full sm:w-1/2">
					<s-button
						ref="submit"
						type="success"
						class="w-full vs-con-loading__container"
						:disabled="isComplete === false || disabled"
						@click="addCollaborator"
					>
						{{ $t("Valider") }}
					</s-button>
				</div>
			</div>
		</vs-card>
	</div>
</template>
<script>
	import { Validator } from "vee-validate";
	import { mapGetters, mapState } from "vuex";
	import i18n from "../i18n";

	// dictionnaire des messages d'erreur inputs formulaire
	const dict = {
		custom: {
			firstname: {
				required: () => i18n.t("Veuillez entrer un prénom")
			},
			lastname: {
				required: () => i18n.t("Veuillez entrer un nom de famille")
			},
			email: {
				required: i18n.t("Veuillez entrer l’email"),
				email: i18n.t("L’email n’est pas valide"),
				regex: i18n.t("email domaine")
			},
			selectedPolicy: {
				required: i18n.t("Veuillez choisir les droits")
			}
			// password: {
			// 	required: i18n.t("Veuillez entrer un mot de passe"),
			// 	min: i18n.t("Le mot de passe doit faire plus de 8 caractères")
			// },
			// password2: {
			// 	required: i18n.t("Veuillez entrer un mot de passe"),
			// 	min: i18n.t("Le mot de passe doit faire plus de 8 caractères"),
			// 	confirmed: i18n.t("Les mots de passe ne correspondent pas")
			// }
		}
	};

	// appel du dictionnaire pour la validation formulaire
	Validator.localize("fr", dict);

	export default {
		name: "InviteCollaborator",
		data() {
			return {
				apps: null,
				// form
				lastname: null,
				firstname: null,
				email: null,
				// password: null,
				// password2: null,
				sendEmail: true,
				// gestion erreurs
				msgErr: 0,
				complete: false,
				policy_profile_id: null,
				disabled: false
			};
		},
		computed: {
			...mapGetters(["sorted_cases"]),
			...mapState(["user", "loadedPolicies", "partner"]),
			isComplete() {
				return !!(
					this.lastname?.length &&
					this.firstname?.length &&
					this.email?.length &&
					this.policy_profile_id &&
					(this.sendEmail ||
						(!this.sendEmail &&
							this.password?.length &&
							this.password2?.length &&
							this.password === this.password2))
				);
			},
			filtered_policies() {
				if (!this.loadedPolicies) return [];
				return this.loadedPolicies.filter(policy => !policy.visible && !policy.restricted);
			}
		},
		// watch: {
		// 	partner: {
		// 		handler(newPartner) {
		// 			if (newPartner && newPartner.app_id && !this.$store.state.loadedPolicies) {
		// 				this.$store.dispatch("getPolicies", newPartner.app_id).then(() => {
		// 					this.policy_profile_id = this.filtered_policies[0]?.id || null;
		// 				});
		// 			}
		// 		},
		// 		immediate: true
		// 	}
		// },
		async mounted() {
			if (this.apps === null) this.apps = await this.$store.dispatch("getApps");
			if (this.loadedPolicies == null) this.$store.dispatch("getPolicies", this.apps[0].id);
		},
		methods: {
			goBack() {
				this.$router.push({ path: "/collaborators", query: this.$route.query });
			},
			async addCollaborator() {
				const isFormValid = await this.$validator.validateAll();
				if (isFormValid) {
					const payload = {
						partnerId: this.user?.partner_id,
						email: this.email,
						firstname: encodeURIComponent(this.firstname),
						lastname: encodeURIComponent(this.lastname),
						policy_profile_id: this.policy_profile_id
					};

					this.disabled = true;
					this.$vs.loading({
						type: "default",
						color: "var(--white)",
						background: "var(--success)",
						container: this.$refs.submit.$el,
						scale: 0.5
					});

					this.$store
						.dispatch("sendInviteCollaborator", payload)
						.then(async () => {
							const title = this.sendEmail ? i18n.t("Invitation envoyée") : i18n.t("Utilisateur créé");
							const text = this.sendEmail
								? i18n.t("Un nouvel utilisateur a été créé, un email d’invitation vient d’être envoyé.")
								: i18n.t("Un nouvel utilisateur a été créé, vous pouvez ...");

							this.$vs.notify({
								title,
								text,
								color: "success",
								iconPack: "feather",
								icon: "icon-check",
								time: 5000
							});

							this.goBack();
							this.msgErr = 200;
							this.$vs.loading.close(this.$refs.submit.$el);
						})
						.catch(err => {
							this.msgErr = err?.response?.status;
							console.log(err.response?.data?.message || err);
							this.$vs.notify({
								title: i18n.t(
									err.response?.data?.message ||
										"Une erreur est survenue, lors de l’ajout du collaborateur."
								),
								color: "danger",
								iconPack: "feather",
								icon: "icon-alert-triangle",
								time: 15000
							});
							this.$vs.loading.close(this.$refs.submit.$el);
						})
						.finally(() => {
							this.disabled = false;
						});
				}
			}
		}
	};
</script>

<style scoped>
	.border-rounded {
		padding: 0.5rem 0.75rem !important;
		border: 1px solid var(--border);
		border-radius: 6px !important;
		color: var(--text) !important;
	}
</style>
